import { LogOut, ShoppingCart, Bell, Menu, Store, Sparkles } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";

import { useAuthStore } from "@/store/auth-store";
import { useUIStore } from "@/store/ui-store";
import { APP_NAME } from "@/lib/constants";
import { RightSidebar } from "./RightSidebar";

export function Topbar({ onOpenCart }: { onOpenCart: () => void }) {
  const { user, logout } = useAuthStore();
  const cartCount = Object.values(useUIStore((s) => s.cart)).reduce((a, b) => a + b, 0);
  const toggleMobileMenu = useUIStore((s) => s.toggleMobileMenu);
  const nav = useNavigate();
  
  // State for the Right Sidebar Drawer (Vendors/Shops)
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);

  return (
    <>
      <header className="h-16 bg-white/80 backdrop-blur-xl border-b border-surface-200 sticky top-0 z-30 px-4 sm:px-6 flex items-center justify-between shadow-sm">
        
        {/* 🌟 LEFT SIDE: Menu & Logo */}
        <div className="flex items-center gap-4 sm:gap-6">
          <button 
            onClick={toggleMobileMenu}
            className="p-2 -ml-2 rounded-lg text-surface-600 hover:bg-surface-100 transition-colors"
          >
            <Menu className="h-6 w-6" />
          </button>

          <Link to="/" className="flex items-center gap-2">
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="h-8 w-auto object-contain shrink-0" 
            />
          </Link>
        </div>

        {/* 🌟 RIGHT SIDE: Actions & User */}
        <div className="flex items-center gap-2 sm:gap-3">
          
          {/* Shops Drawer Button (Matches Public Layout) */}
          

          <div className="flex items-center gap-1 sm:gap-2 border-r border-surface-200 pr-2 sm:pr-3 mr-1 sm:mr-2">
            <button onClick={() => nav("/dashboard/notifications")}
                    className="relative h-10 w-10 flex items-center justify-center rounded-xl hover:bg-surface-100 text-surface-600 transition-colors">
              <Bell className="h-5 w-5" />
            </button>

            <button onClick={onOpenCart}
                    className="relative h-10 w-10 flex items-center justify-center rounded-xl hover:bg-surface-100 text-surface-600 transition-colors">
              <ShoppingCart className="h-5 w-5" />
              {cartCount > 0 && (
                <span className="absolute top-1.5 right-1.5 h-4 min-w-[16px] px-1 rounded-full bg-brand-600 text-white text-[10px] font-bold flex items-center justify-center shadow-sm">
                  {cartCount}
                </span>
              )}
            </button>
          </div>

          <div className="flex items-center gap-3">
            <button 
            onClick={() => setRightDrawerOpen(true)} 
            className="hidden sm:flex items-center gap-2 px-3 h-10 rounded-xl bg-surface-100 hover:bg-surface-200 text-surface-700 font-bold text-sm transition-colors"
          >
            <Store className="w-4 h-4" /> Shops
          </button>
            <button onClick={() => { logout(); nav("/login"); }}
                    className="hidden sm:flex h-10 w-10 items-center justify-center rounded-xl hover:bg-danger-50 hover:text-danger-600 text-surface-400 transition-colors"
                    title="Logout">
              <LogOut className="h-4.5 w-4.5" />
            </button>
          </div>
        </div>
      </header>

      {/* 🌟 The Right Sidebar Drawer (Passes the open state to it) */}
      <RightSidebar open={rightDrawerOpen} onClose={() => setRightDrawerOpen(false)} />
    </>
  );
}